/**
 * V2 观众端 SSE 的序号判断。不用于 applyInit，也不用于 CR V3 喂数。
 */

export interface RevisionRow {
  revision?: number
  source_text?: string
  translations?: Record<string, string>
}

export function revisionOf(row: { revision?: number } | null | undefined): number | null {
  const revision = row?.revision
  return typeof revision === 'number' ? revision : null
}

export function maxFragmentRevision(rows: Array<{ revision?: number }> | undefined): number {
  let max = 0
  for (const row of rows ?? []) {
    const revision = revisionOf(row)
    if (revision != null && revision > max) max = revision
  }
  return max
}

function isEmptyRow(row: RevisionRow): boolean {
  if ((row.source_text || '').trim()) return false
  return !Object.values(row.translations || {}).some((value) => String(value || '').trim())
}

/** 返回下一条应显示的中间行。忽略过期 preview 时保留当前行。 */
export function nextV2Preview(
  current: RevisionRow | null,
  incoming: RevisionRow | null | undefined,
  lastFragmentRevision: number,
): RevisionRow | null {
  if (!incoming) return current
  const revision = revisionOf(incoming)
  const currentRevision = revisionOf(current)
  if (isEmptyRow(incoming)) {
    if (revision == null) return null
    if (currentRevision == null || revision >= currentRevision) return null
    return current
  }
  if (revision != null && revision <= lastFragmentRevision) return current
  if (revision != null && currentRevision != null && revision <= currentRevision) return current
  return incoming
}

/** applyInit 使用。不看 revision，空内容才清空。 */
export function previewFromInit(preview: RevisionRow | null | undefined): RevisionRow | null {
  if (!preview || isEmptyRow(preview)) return null
  return preview
}

/** V2 fragment 事件：清掉中间行，并抬高已见定稿序号。 */
export function noteV2Fragment(
  lastFragmentRevision: number,
  fragment: { revision?: number },
): { preview: null; lastFragmentRevision: number } {
  const revision = revisionOf(fragment)
  return {
    preview: null,
    lastFragmentRevision:
      revision != null && revision > lastFragmentRevision ? revision : lastFragmentRevision,
  }
}
